import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser, AuthTokens } from '@amarfuel/shared-types';
interface AuthState {
  user: AuthUser | null; tokens: AuthTokens | null; isAuthenticated: boolean;
  setAuth: (user: AuthUser, tokens: AuthTokens) => void; updateUser: (user: Partial<AuthUser>) => void;
  setTokens: (tokens: AuthTokens) => void; logout: () => void;
}
export const useAuthStore = create<AuthState>()(persist((set) => ({
  user: null, tokens: null, isAuthenticated: false,
  setAuth: (user, tokens) => set({ user, tokens, isAuthenticated: true }),
  updateUser: (partial) => set((s) => ({ user: s.user ? { ...s.user, ...partial } : null })),
  setTokens: (tokens) => set({ tokens }),
  logout: () => set({ user: null, tokens: null, isAuthenticated: false }),
}), { name: 'amarfuel-auth', partialize: (s) => ({ user: s.user, tokens: s.tokens, isAuthenticated: s.isAuthenticated }) }));
